// extracted by mini-css-extract-plugin
module.exports = {"panelContainer":"index_panelContainer_3Uo9T","quarterContainer":"index_quarterContainer_3SvWd","iconContainer":"index_iconContainer_3aKjJ"};